import loopbackClient from '../lib/react-admin-loopback';

export const dataProvider = loopbackClient(
	process.env.REACT_APP_API_URL
);